export default {
	GET_VALIDATE_REQUEST_CANCELLATION_RESULT: state => state.validateRequestCancellationResult,
	GET_CANCELLATION_SETTING: state => state.cancellationSetting,
}